import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { Helmet } from "react-helmet";

const TermsOfUse = () => {
    const navigate = useNavigate();

    const handleClose = () => {
        navigate(-1); // Navigate back to the previous page
    };

    return (
      <TermsContainer>
        <Helmet>
          <title>Terms of Use | SolarAIDD</title>
          <meta name="description" content="Review the official terms of service for SolarAIDD. Guidelines on AI software usage, EL image analysis licensing, and CSIR intellectual property rights."/>
          <meta name="keywords" content="SolarAIDD terms of service, AI software license, PV inspection agreement, CSIR software terms, usage rights, solar data processing terms"/>
          <meta name="robots" content="index, follow" />
          <link rel="canonical" href="https://solaraidd.csir.co.za/terms-of-use" />

          {/* Breadcrumb Schema to help Google understand site hierarchy */}
          <script type="application/ld+json">
            {`
              {
                "@context": "https://schema.org",
                "@type": "BreadcrumbList",
                "itemListElement": [{
                  "@type": "ListItem",
                  "position": 1,
                  "name": "Home",
                  "item": "https://solaraidd.csir.co.za/"
                },{
                  "@type": "ListItem",
                  "position": 2,
                  "name": "Terms of Use"
                }]
              }
            `}
          </script>
        </Helmet>
  
        <SectionTitle>1. Introduction</SectionTitle>
        <Paragraph>
          Welcome to our platform. By using our services, you agree to the following terms of use.
          Please read these terms carefully before using our website or services.
        </Paragraph>
  
        <SectionTitle>2. Acceptance of Terms</SectionTitle>
        <Paragraph>
          By accessing or using our services, you agree to be bound by these terms, including any future modifications. If you do not agree to these terms, you should not use our services.
        </Paragraph>
  
        <SectionTitle>3. User Responsibilities</SectionTitle>
        <Paragraph>
          You are responsible for all activity that occurs under your account, and you agree not to use the service for any illegal or unauthorized purpose. You must not violate any laws in your jurisdiction while using our service.
        </Paragraph>
  
        <SectionTitle>4. Account Registration</SectionTitle>
        <Paragraph>
          You may need to register an account to access certain services. You are responsible for maintaining the confidentiality of your account information and for all activities that occur under your account.
        </Paragraph>
  
        <SectionTitle>5. Termination</SectionTitle>
        <Paragraph>
          We may terminate or suspend access to our services immediately, without prior notice or liability, for any reason whatsoever, including but not limited to a breach of the terms.
        </Paragraph>
  
        <SectionTitle>6. Changes to Terms</SectionTitle>
        <Paragraph>
          We reserve the right to modify these terms at any time. Your continued use of the service after any such changes constitutes your acceptance of the new terms.
        </Paragraph>
  
        <SectionTitle>7. Contact Us</SectionTitle>
        <Paragraph>
          If you have any questions about these Terms of Use, please contact us at  solaraiddsupport@csir.co.za.
        </Paragraph>
      </TermsContainer>
    );
};
  
export default TermsOfUse;

const TermsContainer = styled.div`
  padding: 40px;
  max-width: 800px;
  margin: 0 auto;
  background-color: #f9f9f9;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.65);
`;

const SectionTitle = styled.h2`
  font-size: 1.5rem;
  margin-top: 20px;
  color: #333;
`;

const Paragraph = styled.p`
  font-size: 1rem;
  line-height: 1.6;
  color: #666;
  margin-bottom: 20px;
`;